import type { SVGProps } from 'react';

const SvgMessageSuccess = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M19.2 10.38c-.52.19-.79.76-.6 1.28.13.36.04.77-.23 1.05l-1.07 1.07a1 1 0 0 0-.29.71V16c0 .55-.45 1-1 1H14.5c-.27 0-.52.11-.71.29l-1.07 1.07a.996.996 0 0 1-1.41 0l-1.07-1.07a1 1 0 0 0-.71-.29H8.02c-.55 0-1-.45-1-1v-1.51c0-.27-.11-.52-.29-.71l-1.07-1.07a.996.996 0 0 1 0-1.41l1.07-1.07a1 1 0 0 0 .29-.71V8.01c0-.55.45-1 1-1h1.51c.27 0 .52-.11.71-.29l1.07-1.07a.996.996 0 0 1 1.41 0l1.07 1.07c.19.19.44.29.71.29h.48c.55 0 1-.45 1-1s-.45-1-1-1l-.84-.78c-1.15-1.14-3.13-1.14-4.26-.01L9.1 5H8C6.35 5 5 6.35 5 8v1.1l-.78.78c-.57.57-.88 1.32-.88 2.12s.31 1.55.88 2.12l.78.78V16c0 1.65 1.35 3 3 3h1.1l.78.78c.57.57 1.32.88 2.12.88s1.55-.31 2.12-.88l.78-.78H16c1.65 0 3-1.35 3-3v-1.1l.78-.78c.82-.82 1.09-2.05.7-3.13a1 1 0 0 0-1.28-.6z"
    />
    <path
      fill="currentcolor"
      d="M9.71 10.38a.996.996 0 1 0-1.41 1.41l2.91 2.91c.19.19.44.29.71.29s.52-.11.71-.29l7.99-7.99a.996.996 0 1 0-1.41-1.41l-7.29 7.29z"
    />
  </svg>
);
export default SvgMessageSuccess;
